import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get, del } from "@utils/axios_api";
import { downloadExcel } from "@utils/downloadExcel";
/**
 * 목록조회 + 삭제 + 업체 목록 엑셀 다운 로직을 담당하는 훅
 */
const fetchCompanyList = async (params) => {
    const response = await get("/admin/comp/companyList", { params });
    return response;
};
export function useCompany(queryParam) {
  const [selectedItems, setSelectedItems] = useState([]);


  const { data, refetch } = useQuery({
    queryKey: ["selectAdminCompanyList", queryParam],
    queryFn: () => fetchCompanyList(queryParam),
    keepPreviousData: true,
  });

  const handleSelectAll = (checked) => {
    if (!data || !data.resultList) return;
    if (checked) {
      const allBiz = data.resultList.map((item) => item.bizRegNo);
      setSelectedItems(allBiz);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (biz) => {
    if (selectedItems.includes(biz)) {
      setSelectedItems(selectedItems.filter((x) => x !== biz));
    } else {
      setSelectedItems([...selectedItems, biz]);
    }
  };

  const handleDelete = async () => {
    if (!selectedItems.length) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }

    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");
    if (!isConfirmed) return;
    
    try {
      const response = await del("/admin/comp/deleteCompany", {
        data: {
          bizlist: selectedItems,
        },
      });
      alert(response?.message);
      refetch(); 
      setSelectedItems([]); 
    } catch (err) {
      console.error(err);
      alert("삭제 실패");
    }
  };

  const handleExcelDownload = (e) => {
    e.preventDefault();
    downloadExcel({
      url: "/admin/comp/companyListExcelDown",
      params: queryParam,
      filePrefix: "업체 목록",
    });

  }


  const isAllChecked = !!(data?.resultList?.length && selectedItems.length === data?.resultList?.length);

  return { data, refetch, selectedItems, isAllChecked,  handleSelectAll, handleSelectItem, handleExcelDownload, handleDelete };
}
